import React, { Component } from 'react';
import { DataFonctionnalite } from '../../data/DataFonctionnalite.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';

export class ComboBoxFonctionnalite extends Component {

    static defaultProps = {
        idDomaine: undefined,
        label: "Fonctionnalité",
        placeholder: "Fonctionnalité",
    };

    render = () => {

        const { disabled, idDomaine } = this.props;

        let fetchMethod = null;
        if (!!idDomaine)
            fetchMethod = () => DataFonctionnalite._chargementDesFonctionnalites(idDomaine);

        return <EUIComboBox
            {...this.props}
            disabled={disabled || !idDomaine}
            fetchMethod={fetchMethod}
            itemKey={item => item.idFonctionnalite}
            itemText={item => item.fonctionnalite}
            stamp={idDomaine}
        />;

    };

};